import React from "react";
import DirectoryMarketCards, { marketsFromPlaces } from "@/components/DirectoryMarketCards";
import "./AgentBioMarkets.scss";

export const bioPlaces = (agent) =>
  [...(agent?.activeWantAds || []), ...(agent?.history?.past || [])].map((wantAd) => ({
    city: wantAd.City,
    state: wantAd.State,
  }));

const AgentBioMarkets = ({ agent }) => {
  const markets = marketsFromPlaces(bioPlaces(agent));
  if (!markets.length) return null;
  return (
    <section className="agent-bio-markets">
      <h2 className="agent-bio-section-title">
        {agent.FirstName ? `Where ${agent.FirstName} works` : "Where this agent works"}
      </h2>
      <DirectoryMarketCards markets={markets} label="Where this agent works" />
    </section>
  );
};

export default AgentBioMarkets;
